import { render, staticRenderFns } from "./modalRetificar.vue?vue&type=template&id=1a9eb40d&scoped=true&lang=pug&"
import script from "./modalRetificar.vue?vue&type=script&lang=js&"
export * from "./modalRetificar.vue?vue&type=script&lang=js&"
import style0 from "./modalRetificar.vue?vue&type=style&index=0&id=1a9eb40d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9eb40d",
  null
  
)

export default component.exports